var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Setor",
      "outlined": "",
      "dense": "",
      "maxlength": "40"
    },
    model: {
      value: _vm.form.filters.nome,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "nome", $$v);
      },
      expression: "form.filters.nome"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Origem",
      "dense": "",
      "outlined": "",
      "item-text": function (v) {
        return v.nome.toUpperCase();
      },
      "item-value": "id",
      "items": _vm.form.lists.origens
    },
    model: {
      value: _vm.form.filters.origem,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "origem", $$v);
      },
      expression: "form.filters.origem"
    }
  })], 1), _c('sigfoco-select-ativo', {
    attrs: {
      "cols": 3,
      "labelType": "Situação"
    },
    model: {
      value: _vm.form.filters.ativo,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "ativo", $$v);
      },
      expression: "form.filters.ativo"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarSetores();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Incluir",
      "icon": "mdi-plus"
    },
    on: {
      "click": function ($event) {
        return _vm.openDialogManterSetor();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.origem`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.origem.toUpperCase()) + " ")];
      }
    }, {
      key: `item.ativo`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sigfoco-label-ativo-inativo', {
          attrs: {
            "ativo": item.ativo
          }
        })];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar",
            "icon": "mdi-eye-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarSetor(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Editar",
            "icon": "mdi-pencil",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogManterSetor(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Excluir",
            "icon": "mdi-delete",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.excluirSetor(item);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": `${item.ativo ? 'Inativar' : 'Ativar'}`,
            "icon": `${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`,
            "color": `${item.ativo ? 'var(--primary-button-color)' : 'silver'}`,
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.alterarStatusSetor(item);
            }
          }
        })];
      }
    }, {
      key: `item.emUso`,
      fn: function (_ref4) {
        var item = _ref4.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": 'Detalhar Uso',
            "icon": item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline',
            "color": item.emUso ? 'green' : 'red',
            "small": true,
            "disabled": !item.emUso
          },
          on: {
            "click": function ($event) {
              item.emUso ? _vm.openDialogDetalharUsoSetor(item) : null;
            }
          }
        })];
      }
    }], null, true)
  })], 1), _vm.dialogVisualizarSetor.visible ? _c('VisualizarSetorDialog', {
    attrs: {
      "funcoes": _vm.form.lists.funcoes,
      "visible": _vm.dialogVisualizarSetor.visible,
      "content": _vm.dialogVisualizarSetor.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarSetor.close();
      }
    }
  }) : _vm._e(), _vm.dialogManterSetor.visible ? _c('CadastrarEditarSetorDialog', {
    attrs: {
      "funcoes": _vm.form.lists.funcoes,
      "edit": _vm.dialogManterSetor.edit,
      "visible": _vm.dialogManterSetor.visible,
      "content": _vm.dialogManterSetor.content,
      "origens": _vm.form.lists.origens
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogManterSetor.close();
      },
      "onSave": function ($event) {
        return _vm.buscarSetores();
      }
    }
  }) : _vm._e(), _c('DetalharUsoSetorDialog', {
    attrs: {
      "visible": _vm.dialogDetalharUsoSetor.visible,
      "content": _vm.dialogDetalharUsoSetor.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogDetalharUsoSetor.close();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }